import { ru as dateFnsLocaleRu } from "date-fns/locale";
import { ru as core } from "@xbs/wx-core-locales";
export const ru = {
    ...core,
    dateFnsLocale: dateFnsLocaleRu,
    scheduler: {
        "New Event": "Новое событие",
        "Add description": "Описание",
        "Create event": "Создать событие",
        "Edit event": "Редактировать",
        "Delete event": "Удалить",
        "Event name": "Название",
        "Start date": "Дата начала",
        "End date": "Дата окончания",
        "All day": "Весь день",
        "No events": "Нет событий",
        Type: "Тип",
        Description: "Описание",
        Today: "Сегодня",
        Day: "День",
        Week: "Неделя",
        Month: "Месяц",
        Year: "Год",
        Agenda: "Расписание",
        Timeline: "График",
        Calendars: "Календари",
        hourFormat: "H",
        minuteFormat: "mm",
        monthFormat: "EEE",
        dateFormat: "EEE, d",
        agendaDateFormat: "MMMM d EEEE",
        unassignFormat: "d MMM yyyy",
        Color: "Цвет",
        Delete: "Удалить",
        Edit: "Редактировать",
        Calendar: "Календарь",
        New: "Новый",
        Name: "Имя",
        Save: "Сохранить",
        Add: "Добавить",
        confirmDelete: "Вы уверены, что хотите удалить это событие?",
        confirmUnsaved: "У вас есть несохраненные изменения! Вы действительно хотите отменить их?",
        "Repeat event": "Повотрять событие",
        Never: "Никогда",
        Every: "Каждый",
        Workdays: "По будним дням",
        Custom: "Другое",
        Ends: "Заканчивается",
        After: "После",
        "On date": "Дата",
        events: "событий",
        "recurring event": "повторяющееся событие",
        all: "Все события",
        future: "Это и последующие события",
        only: "Только это событие",
        recurringActionError: "Начало события не может быть установлено после даты завершения повторяющегося события",
        assignees: "Относится",
        "Recurring events": "Повторяющиеся события",
        "Single events": "Одиночные события",
        recurringEveryMonthDay: "Каждое {date} число",
        recurringEveryMonthPos: "Каждый {pos} {weekDay}",
        recurringEveryYearDay: "Каждое {date} число {month}",
        recurringEveryYearPos: "Каждый {pos} {weekDay}  {month}",
    },
};
//# sourceMappingURL=ru.js.map